// eslint-disable-next-line import/prefer-default-export
export const DEFAULT_SETUP_PRODUCT_NAME = "Oprettelse";
